import { ClbButton } from '@celebration/react';

function TableAnchorScrollLink({
    elementId,
}: Readonly<{
    elementId: string;
}>) {
    return (
        <ClbButton
            size="sm"
            styleType="tertiary"
            onClick={() => document.getElementById(elementId)?.scrollIntoView()}
            label="mais..."
            data-testid="table-anchor-scroll-link"
        />
    );
}

export default TableAnchorScrollLink;
